export enum EbookSearchTypeEnum {
  HIT_ON_TREND = 'HIT_ON_TREND',
  NEW_EBOOK = 'NEW_EBOOK',
  PROMOTION = 'PROMOTION',
  TOP_CHART = 'TOP_CHART',
  ALL = 'ALL',
}
